export default (that) => [
  {
    field: 'seq',
    width: 50,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_quotationNo') || '报价单号',
    field: 'quotationNo',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_quotationStatus') || '执行状态',
    field: 'quotationStatus',
    minWidth: 125,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'quotationStatus' },
  },
  {
    title: that.$l('table_label_requestDate') || '报价日期',
    field: 'requestDate',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_cust') || '客户',
    field: 'custName',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_salesPerson') || '业务人员',
    field: 'salesPersonName',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
